module.exports = __webpack_public_path__ + "static/media/building_subscription_modal_image.f9694a71.jpg";